import * as Sentry from '@sentry/browser'
import { ENV, CONSTANTS } from 'pobble-components/dist/setup'

const enableSentry = () => {
  Sentry.init({
    dsn: CONSTANTS.SENTRY_DSN_KEY,
    beforeSend: (event, hint) => {
      // Filter out all HTTP errors and all IE errors
      if (
        hint.originalException
          .toString()
          .indexOf('Request failed with status code') !== -1 ||
        navigator.userAgent.indexOf('MSIE') !== -1 ||
        navigator.userAgent.indexOf('Trident') !== -1
      ) {
        return null
      }

      return event
    }
  })
}

if (ENV === 'prod') {
  enableSentry()
}
